// @givmo/app-admin — dashboard section status helpers (loading/error surfaces).
//
// The three status primitives every dashboard section shares: the error-message reader, the inline
// retry block, and its card-wrapped form. Extracted VERBATIM from `dashboard-page.tsx` when the page
// was decomposed into sections (EP-W1 PR1) — same markup, same classes, same copy.

import { isGivmoError } from '@givmo/api-client';

/** The message a failed query should show: the API's own detail when we have one, else the fallback. */
export const errorMessage = (error: unknown, fallback: string): string =>
  isGivmoError(error) ? error.message : fallback;

export function InlineError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="flex flex-col items-center gap-8 py-24 text-center">
      <p className="font-sans text-s14 font-w500 tracking-givmo text-danger-700">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="font-sans text-s13 font-w600 tracking-givmo text-brand-600 outline-none hover:underline focus-visible:underline"
      >
        Try again
      </button>
    </div>
  );
}

export function ErrorCard({
  message,
  onRetry,
  className,
}: {
  message: string;
  onRetry: () => void;
  className?: string;
}) {
  return (
    <div
      className={`rounded-xl border border-border-subtle bg-surface p-20 shadow-xs ${className ?? ''}`}
    >
      <InlineError message={message} onRetry={onRetry} />
    </div>
  );
}
